/**
 * Theme JavaScript — cart drawer, AJAX add-to-cart, and cart-count sync.
 * Vanilla ES5, progressive enhancement: if anything fails, forms submit and
 * links navigate normally (to /cart), so the store still works without JS.
 */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-cart-drawer]');
  var panel = drawer && drawer.querySelector('[data-cart-panel]');

  /* ---------- open / close ---------- */
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.remove('pointer-events-none', 'opacity-0');
    drawer.classList.add('opacity-100');
    if (panel) panel.classList.remove('translate-x-full');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.add('pointer-events-none', 'opacity-0');
    drawer.classList.remove('opacity-100');
    if (panel) panel.classList.add('translate-x-full');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  /* ---------- cart count badges ---------- */
  function updateCount(count) {
    if (typeof count !== 'number' || isNaN(count)) return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.classList.toggle('hidden', count === 0);
    });
  }

  /* ---------- swap drawer contents from a rendered section ---------- */
  function renderContents(html) {
    if (!drawer || !html) return;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var next = parsed.querySelector('[data-cart-contents]');
    var current = drawer.querySelector('[data-cart-contents]');
    if (next && current) {
      current.replaceWith(next);
      updateCount(parseInt(next.getAttribute('data-item-count'), 10));
    }
  }

  var SECTION = 'cart-drawer';
  function sectionsUrl() { return window.location.pathname; }

  /* ---------- add to cart (AJAX) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!drawer) return; // no drawer -> let it submit normally

    e.preventDefault();
    var submitButtons = document.querySelectorAll('[form="' + form.id + '"], form[action*="/cart/add"] [type="submit"]');
    submitButtons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });

    var body = new FormData(form);
    body.append('sections', SECTION);
    body.append('sections_url', sectionsUrl());

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) return; // add error (e.g. out of stock)
        if (data && data.sections && data.sections[SECTION]) {
          renderContents(data.sections[SECTION]);
        }
        openDrawer();
      })
      .catch(function () { form.submit(); })
      .then(function () {
        submitButtons.forEach(function (b) { b.removeAttribute('aria-busy'); });
      });
  });

  /* ---------- quantity change / remove (delegated) ---------- */
  document.addEventListener('click', function (e) {
    var line = e.target.closest && e.target.closest('[data-line-key]');
    if (!line || !drawer || !drawer.contains(line)) return;
    e.preventDefault();
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: line.getAttribute('data-line-key'),
        quantity: parseInt(line.getAttribute('data-qty'), 10),
        sections: SECTION,
        sections_url: sectionsUrl()
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && cart.sections && cart.sections[SECTION]) renderContents(cart.sections[SECTION]);
        if (cart && typeof cart.item_count === 'number') updateCount(cart.item_count);
      })
      .catch(function () {});
  });

  /* ---------- open / close triggers ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (e.target.closest('[data-cart-overlay]')) { closeDrawer(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
  });
})();

/* ═══════════════ Predictive search overlay ═══════════════ */
(function () {
  'use strict';

  var overlay = document.querySelector('[data-search]');
  if (!overlay) return;

  var input = overlay.querySelector('[data-search-input]');
  var results = overlay.querySelector('[data-search-results]');
  var suggestUrl = overlay.getAttribute('data-suggest-url') || '/search/suggest';

  function open() {
    overlay.classList.remove('pointer-events-none', 'opacity-0');
    overlay.classList.add('opacity-100');
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    if (input) setTimeout(function () { input.focus(); }, 50);
  }
  function close() {
    overlay.classList.add('pointer-events-none', 'opacity-0');
    overlay.classList.remove('opacity-100');
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  var timer = null, controller = null;
  function query() {
    var q = input.value.trim();
    if (q.length < 2) { results.innerHTML = ''; return; }

    if (controller) controller.abort();
    controller = new AbortController();

    var url = suggestUrl +
      '?q=' + encodeURIComponent(q) +
      '&section_id=predictive-search' +
      '&resources[type]=product,collection' +
      '&resources[limit]=8';

    fetch(url, { signal: controller.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        // Response is the rendered section; grab its inner content.
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('.shopify-section') || doc.body;
        results.innerHTML = section.innerHTML;
      })
      .catch(function () { /* aborted or offline — ignore, form still submits */ });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-search-toggle]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-search-close]') || e.target.closest('[data-search-overlay]')) { close(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') close();
  });

  if (input) {
    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(query, 220);
    });
  }
})();
